export default __webpack_public_path__ + "static/media/sample_test_taking_1.98c64ec8.png";